import ThemeProvider from '@theme/index';
import { router } from '@routes/index';
import { RouterProvider } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import { LayoutSettingContextProvider } from '@contexts/LayoutSettingContext';
import SnackbarProvider from '@contexts/SnackbarContext';
import { ConfirmDialogContextProvider } from '@contexts/ConfirmDialogContext';
import { AuthContextProvider } from '@contexts/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import { BadgeContextProvider } from '@contexts/BadgeContext';
import { PointContextProvier } from '@contexts/PointContext';
import { VoteContextProvider } from '@contexts/VoteContext';
import { UserContextProvider } from '@contexts/UserContext';
import { KAKAO_JS_KEY } from '@utils/const';

function App() {
  useEffect(() => {
    const { Kakao } = window;
    if (Kakao && !Kakao.isInitialized()) Kakao.init(KAKAO_JS_KEY);
  }, []);

  return (
    <ThemeProvider>
      <SnackbarProvider>
        <AuthContextProvider>
          <ConfirmDialogContextProvider>
            <HelmetProvider>
              <LayoutSettingContextProvider>
                <BadgeContextProvider>
                  <PointContextProvier>
                    <VoteContextProvider>
                      <UserContextProvider>
                        <Suspense>
                          <RouterProvider router={router} />
                        </Suspense>
                      </UserContextProvider>
                    </VoteContextProvider>
                  </PointContextProvier>
                </BadgeContextProvider>
              </LayoutSettingContextProvider>
            </HelmetProvider>
          </ConfirmDialogContextProvider>
        </AuthContextProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
